import { NoAccess } from "@newrai/ant-design";
import { AuthProvider } from "config/auth/AuthProvider";
import Settings from "config/settings";
import { lazy, Suspense } from "react";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import LoadingPage from "views/Base/components/LoadingPage";
import Page404 from "views/Base/components/Page404";
import PrivateRoute from "./PrivateRoute";

const Home = lazy(() => import("views/Home"));
const Documents = lazy(() => import("views/Documents"));

const routes: ReturnType<typeof createBrowserRouter> = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/"
        element={
          <AuthProvider>
            <PrivateRoute />
          </AuthProvider>
        }
      >
        <Route
          index
          element={
            <Suspense fallback={<LoadingPage />}>
              <Home />
            </Suspense>
          }
        />
        <Route
          path="accounting-firm/:accountingFirmID"
          element={
            <Suspense fallback={<LoadingPage />}>
              <Home />
            </Suspense>
          }
        />
        <Route
          path="company/:companyID"
          element={
            <Suspense fallback={<LoadingPage />}>
              <Documents />
            </Suspense>
          }
        >
          <Route
            path="book/:bookID"
            element={
              <Suspense fallback={<LoadingPage />}>
                <Documents />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Suspense fallback={<LoadingPage />}>
              <Page404 />
            </Suspense>
          }
        />
      </Route>
      <Route path="no-access" element={<NoAccess dashboardUrl={Settings.dashboard} />} />
    </>,
  ),
);

export { routes };
